// Display-only helpers for the Markets page & Market Intelligence detail (Lodge & Co style).
export const frNum = (n, d = 0) =>
  Number(n).toLocaleString("fr-FR", { minimumFractionDigits: d, maximumFractionDigits: d });

// Compact adaptive number (k / M) for volumes, passengers, spend.
export function fmtCompact(raw) {
  const n = Number(raw) || 0;
  if (Math.abs(n) >= 1e6) return `${frNum(n / 1e6, 1)} M`;
  if (Math.abs(n) >= 1e3) return `${frNum(n / 1e3, 0)} k`;
  return frNum(n, 0);
}

export function scoreLabel(score) {
  if (score == null) return "Non disponible";
  if (score >= 80) return "Très forte opportunité";
  if (score >= 70) return "Forte opportunité";
  if (score >= 55) return "Opportunité";
  if (score >= 40) return "À surveiller";
  return "Faible";
}

// Sober green-scale badge classes matching the Lodge & Co palette.
export function scoreClasses(score) {
  if (score == null) return "border-slate-200 bg-slate-50 text-slate-400";
  if (score >= 80) return "border-[#CBE3D1] bg-[#E7F1E9] text-[#1E6B3A]";
  if (score >= 70) return "border-[#CBE3D1] bg-[#ECF3EC] text-[#2E7D46]";
  if (score >= 55) return "border-amber-200 bg-amber-50 text-amber-700";
  if (score >= 40) return "border-orange-200 bg-orange-50 text-orange-700";
  return "border-rose-200 bg-rose-50 text-rose-700";
}
